import {
  Dashboard as DashboardIcon,
  EventNote as EventNoteIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  BarChart as BarChartIcon,
  VpnKey as VpnKeyIcon,
  ExitToApp as ExitToAppIcon,
} from '@mui/icons-material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import GroupIcon from '@mui/icons-material/Group';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import {
  CUSTOMER_BILLING_ADDRESS,
  CUSTOMER_BOOKINGS,
  CUSTOMER_CHANGE_PASSWORD,
  CUSTOMER_DASHBOARD,
  CUSTOMER_FAMILY_MEMBERS,
  CUSTOMER_INVOICES,
  CUSTOMER_PROFILE_UPDATE,
  CUSTOMER_REFERRALS,
  CUSTOMER_REPORTS,
} from '../Routes/CustomerRoutes';
import { LinkIcon } from 'lucide-react';

export const customerMenuItems = [
  {
    text: 'Dashboard',
    icon: <DashboardIcon sx={{ color: '#3F51B5' }} />,
    path: CUSTOMER_DASHBOARD,
  },

  {
    text: 'Bookings',

    icon: <EventNoteIcon sx={{ color: '#FF9800' }} />,
    path: CUSTOMER_BOOKINGS,
  },

  {
    text: 'Invoices',
    icon: <AccountBalanceWalletIcon sx={{ color: '#D32F2F' }} />,
    path: CUSTOMER_INVOICES,
  },

  // {
  //   text: "Reports",
  //   icon: <BarChartIcon sx={{ color: "#F57C00" }} />,
  //   path: CUSTOMER_REPORTS
  // },
  
  {
    text: 'Passenger Details',
    icon: <GroupIcon sx={{ color: '#8A2BE2' }} />,
    path: CUSTOMER_FAMILY_MEMBERS,
  },

  {
    text: 'Billing Address',
    icon: <LocationOnIcon sx={{ color: '#4CAF50' }} />,
    path: CUSTOMER_BILLING_ADDRESS,
  },
  // {
  //   text: 'Referrals',
  //   icon: <LinkIcon />,
  //   path: CUSTOMER_REFERRALS
  // },
  {
    text: 'Profile',
    icon: <AccountCircleIcon sx={{ color: '#2196F3' }} />,
    path: CUSTOMER_PROFILE_UPDATE,
  },
  {
    text: 'Change Password',
    icon: <VpnKeyIcon sx={{ color: '#009688' }} />,
    path: CUSTOMER_CHANGE_PASSWORD,
  },

  {
    text: 'Logout',
    icon: <ExitToAppIcon sx={{ color: '#CC0033' }} />,
    action: 'logout',
  },
];
